export const getDesksEndPoint = 'Acceptance/get_desks';
